
import { Inject, Injectable } from '@angular/core';
import { LoadProfileStateFail, ProfileActionTypes, VerifyEIN, VerifyEINSuccess, SubmitProfileDetail, SubmitProfileDetailSuccess, SetPassword, SetPasswordSuccess } from './profile.actions';
import { IExternalData, LGEDataService } from '../../../commons';
import { LoadExternalProfileState } from '../../login/state/login.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, from, map, of, switchMap } from 'rxjs';

@Injectable()
export class ProfileEffects {
  private externalData: any;
  verifyEIN$ = createEffect(
    () => this.actions$.pipe(
      ofType(ProfileActionTypes.VerifyEIN),
      map((action: VerifyEIN) => action.externalData),
      switchMap(
        (externalData) => {
          this.externalData = externalData;
          return this.lgeData.CharityCheck(externalData.orgInfoExt.EIN);
        }
      ),
      switchMap(
        (gsOrgInfo: any) => {
          if (typeof gsOrgInfo === 'string' && gsOrgInfo === "invalid") {
            this.externalData.externalUser.accessStatus = "pendingEIN";
            return [new VerifyEINSuccess("Your organization information and tax-exempt status cannot be verified. Please contact contributions@lge-ku.com with questions."), new SubmitProfileDetail(this.externalData)]
          } else {
            this.externalData.orgInfoExt.subsection_501 = gsOrgInfo.subsection_501;
            return [new VerifyEINSuccess("Successfully verified your organization information"), new SubmitProfileDetail(this.externalData)]
          }
        }
      ),
      catchError(error => of(new LoadProfileStateFail(error)))
    )
  )
  submitProfileDetail$ = createEffect(
    () => this.actions$.pipe(
      ofType(ProfileActionTypes.SubmitProfileDetail),
      map((action: SubmitProfileDetail) => action.profile),
      switchMap(profile => this.lgeData.externalProfileEditDetails(profile)),
      switchMap(() => [new SubmitProfileDetailSuccess("Successfully saved your change(s)!"), new LoadExternalProfileState()]),
      catchError(error => of(new LoadProfileStateFail(error)))
    )
  )

  setPassword$ = createEffect(
    () => this.actions$.pipe(
      ofType(ProfileActionTypes.SetPassword),
      map((action: SetPassword) => action.loginInfo),
      switchMap(loginInfo => from(this.lgeData.setPassword(loginInfo)).pipe(
        map(() => new SetPasswordSuccess("Successfully save your new password!")),
        catchError(error => of(new LoadProfileStateFail(error)))
      ))
    )
  )


  constructor(
    private actions$: Actions,
    private lgeData: LGEDataService,
  ) { 

  }
}